import { registerMessages } from "../../i18n/runtime";
import { posEn } from "./messages.en";
import { posEs } from "./messages.es";

registerMessages("en", posEn);
registerMessages("es", posEs);
